/**
 * Kleuren voor bezettingspercentages.
 *
 * Stonden als lokale, niet-geëxporteerde functies in CapacityOverview én WeekOverview.
 * Ze waren toevallig nog identiek — dit is de enige manier om dat zo te houden: wie
 * "97%" op twee schermen naast elkaar ziet moet dezelfde kleur zien, anders vertrouwt
 * niemand het cijfer.
 */

/** Rand/balk-kleur. */
export const getCapacityColor = (pct) => {
  if (pct >= 100) return '#ef4444';
  if (pct >= 80) return '#f97316';
  if (pct >= 50) return '#eab308';
  if (pct > 0) return '#22c55e';
  return '#e5e7eb';
};

/**
 * Cel-stijl {bg, text} voor compacte weergaves (Planner To-Do). Zelfde
 * drempels als getCapacityColor — de 110%-tussenstap die Planner To-Do lokaal
 * had is bewust weg: 97% moet op elk scherm dezelfde kleur zijn.
 */
export const getCapacityCellStyle = (pct) => {
  if (pct >= 100) return { bg: '#fca5a5', text: '#991b1b' };
  if (pct >= 80) return { bg: '#fed7aa', text: '#9a3412' };
  if (pct >= 50) return { bg: '#fef08a', text: '#854d0e' };
  if (pct > 0) return { bg: '#bbf7d0', text: '#166534' };
  return { bg: '#f3f4f6', text: '#6b7280' };
};

/** Achtergrond van de cel. */
export const getCapacityBgColor = (pct) => {
  if (pct >= 100) return '#fef2f2';
  if (pct >= 80) return '#fff7ed';
  if (pct >= 50) return '#fefce8';
  if (pct > 0) return '#f0fdf4';
  return '#f9fafb';
};

/**
 * Dagen die geen gewoon percentage zijn. Een vrije dag en een draaidag zeggen iets
 * anders dan "zo vol staat deze dag": op de een is iemand er niet, op de ander staat
 * hij op locatie. In beide gevallen kun je er niets bij plannen, en dat moet je aan de
 * cel kunnen zien zonder de tooltip te openen — zoals het Airtable-overzicht het deed.
 */
export const DAGSTAAT_STIJL = {
  vrij: {
    tekst: 'Vrij',
    bg: '#dbeafe',
    kleur: '#1d4ed8',
    rand: '#3b82f6',
    titel: 'Vrije dag — niet beschikbaar, hier kan niets gepland worden',
  },
  draaidag: {
    tekst: 'Draaidag',
    bg: '#ffedd5',
    kleur: '#c2410c',
    rand: '#f97316',
    titel: 'Draaidag — de dag is vol, hier kan geen ander werk bij',
  },
  // Twee derde van de draaidagen in de agenda is nog een optie: de dag is
  // vastgehouden maar de klant heeft niet bevestigd. Hij telt wél als bezet —
  // anders plan je er dwars doorheen — maar met een gestreepte achtergrond en
  // het woord "Optie" zie je in één blik waar nog beweging in zit.
  draaidag_optie: {
    tekst: 'Optie',
    bg: 'repeating-linear-gradient(135deg, #fff7ed, #fff7ed 6px, #ffedd5 6px, #ffedd5 12px)',
    kleur: '#c2410c',
    rand: '#fdba74',
    titel: 'Draaidag onder optie — vastgehouden, nog niet bevestigd door de klant. '
      + 'Telt als volle dag zolang hij staat.',
  },
};
